import { UPDATE_CURRENT_BOOKING } from "./bookingConstants";

export const updateBookingForm  = (updateData) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_CURRENT_BOOKING, payload:updateData });
  };
};
